import { useMemo } from 'react';
import { Option } from '../../../general-types';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { ScanMetadata } from '../../interfaces/scanMetadata';
import { getInbodyTypeOptions } from '../../utils/getInbodyTypeOptions/getInbodyTypeOptions';

export const useInbodyTypeOptions = (
  scansMetadata: ScanMetadata[],
): Option<InbodyType>[] => {
  return useMemo(() => getInbodyTypeOptions(scansMetadata), [scansMetadata]);
};
